function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { arrayBufferToBlob, dataURL2ArrayBuffer, dataURL2Blob, parseMeta, updateImageHead } from '../utils';
export var RotateDiection;

(function (RotateDiection) {
  RotateDiection[RotateDiection["HORIZONTAL_FLIP"] = 2] = "HORIZONTAL_FLIP";
  RotateDiection[RotateDiection["ROTATE_LEFT_180"] = 3] = "ROTATE_LEFT_180";
  RotateDiection[RotateDiection["VERTICAL_FLIP"] = 4] = "VERTICAL_FLIP";
  RotateDiection[RotateDiection["VERTICAL_FLIP_ROTATE_RIGHT_90"] = 5] = "VERTICAL_FLIP_ROTATE_RIGHT_90";
  RotateDiection[RotateDiection["ROTATE_RIGHT_90"] = 6] = "ROTATE_RIGHT_90";
  RotateDiection[RotateDiection["HORIZONTAL_FLIP_ROTATE_RIGHT_90"] = 7] = "HORIZONTAL_FLIP_ROTATE_RIGHT_90";
  RotateDiection[RotateDiection["ROTATE_LEFT_90"] = 8] = "ROTATE_LEFT_90";
})(RotateDiection || (RotateDiection = {}));

export var ImageStatus;

(function (ImageStatus) {
  ImageStatus["PREPARE"] = "PREPARE";
  ImageStatus["PENDING"] = "PENDING";
  ImageStatus["FULFILLED"] = "FULFILLED";
  ImageStatus["REJECTED"] = "REJECTED";
})(ImageStatus || (ImageStatus = {}));

export var ImageManage = function () {
  function ImageManage() {
    _classCallCheck(this, ImageManage);

    this.type = '';
    this.quality = 90;
    this.crop = false;
    this.modified = false;
    this.allowMagnify = false;
    this.preserveHeaders = false;
    this.blob = null;
    this.meta = null;
    this.img = null;
    this.canvas = null;
    this.status = ImageStatus.PREPARE;
    this.resolvers = [];
  }

  _createClass(ImageManage, [{
    key: "updateImageOptions",
    value: function updateImageOptions(props) {
      Object.assign(this, props);
    }
  }, {
    key: "initImage",
    value: function initImage(file) {
      var _this = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image/jpeg';
      var img = this.img = new Image();
      img.crossOrigin = 'Anonymous';

      if (typeof file === 'string') {
        this.type = type;
        this.img.src = file;
      } else {
        this.blob = file;
        this.type = file.type;
        this.img.src = URL.createObjectURL(file);

        if (!this.meta && 'image/jpeg' === this.type) {
          parseMeta(this.blob, function (data) {
            _this.meta = data;
          });
        }
      }

      this.status = ImageStatus.PENDING;
      var self = this;

      img.onload = function () {
        if (self.img === this) {
          self.resolvers.slice(0).forEach(function (resolve) {
            return resolve();
          });
          self.status = ImageStatus.FULFILLED;
        }
      };

      img.onerror = function () {
        _this.status = ImageStatus.REJECTED;
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var canvas = this.canvas;

      if (canvas) {
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = canvas.height = 0;
        this.canvas = null;
      }

      if (this.img) {
        URL.revokeObjectURL(this.img.src);
        this.img.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D';
      }

      this.img = null;
      this.blob = null;
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      var _this2 = this;

      var fn = function fn() {
        var canvas = _this2.canvas || (_this2.canvas = document.createElement('canvas'));

        _this2.resizeImage(_this2.img, canvas, width, height);

        _this2.blob = null;
        _this2.modified = true;
        return {
          getBlob: function getBlob(type) {
            return _this2.getAsBlob(type);
          },
          getJpgUrl: function getJpgUrl() {
            return _this2.getJpgUrl();
          },
          getPngUrl: function getPngUrl() {
            return _this2.getPngUrl();
          },
          getImageUrl: function getImageUrl(type, quality) {
            return _this2.getImageUrl(type, quality);
          }
        };
      };

      return this.waitToLoad(fn);
    }
  }, {
    key: "rotate",
    value: function rotate(angle) {
      var _this3 = this;

      var fn = function fn() {
        var cvs = _this3.canvas || (_this3.canvas = document.createElement('canvas'));

        if (_this3.img) {
          var _this3$img = _this3.img,
              width = _this3$img.width,
              height = _this3$img.height;

          _this3.resizeImage(_this3.img, cvs, width, height, angle, true);
        }

        _this3.blob = null;
        _this3.modified = true;
        return {
          getBlob: function getBlob(type) {
            return _this3.getAsBlob(type);
          },
          getJpgUrl: function getJpgUrl() {
            return _this3.getJpgUrl();
          },
          getPngUrl: function getPngUrl() {
            return _this3.getPngUrl();
          },
          getImageUrl: function getImageUrl(type, quality) {
            return _this3.getImageUrl(type, quality);
          }
        };
      };

      return this.waitToLoad(fn);
    }
  }, {
    key: "scale",
    value: function scale(size) {
      var _this4 = this;

      var fn = function fn() {
        var canvas = _this4.canvas || (_this4.canvas = document.createElement('canvas'));

        if (_this4.img) {
          var _this4$img = _this4.img,
              naturalWidth = _this4$img.width,
              naturalHeight = _this4$img.height;
          var w = naturalWidth * size;
          var h = naturalHeight * size;
          canvas.width = w;
          canvas.height = h;

          _this4.renderImageToCanvas(canvas, _this4.img, 0, 0, w, h);
        }

        _this4.blob = null;
        _this4.modified = true;
        return {
          getBlob: function getBlob(type) {
            return _this4.getAsBlob(type);
          },
          getJpgUrl: function getJpgUrl() {
            return _this4.getJpgUrl();
          },
          getPngUrl: function getPngUrl() {
            return _this4.getPngUrl();
          },
          getImageUrl: function getImageUrl(type, quality) {
            return _this4.getImageUrl(type, quality);
          }
        };
      };

      return this.waitToLoad(fn);
    }
  }, {
    key: "cropImage",
    value: function cropImage(startX, startY, width, height, clipWidth, clipHeight) {
      var _this5 = this;

      var fn = function fn() {
        var canvas = _this5.canvas || (_this5.canvas = document.createElement('canvas'));
        var ctx = canvas.getContext('2d');
        var canvasCopy = document.createElement('canvas');
        var copyContext = canvasCopy.getContext('2d');

        if (_this5.img) {
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(_this5.img, startX, startY, width, height, 0, 0, width, height);
        }

        if (clipWidth && clipHeight) {
          canvasCopy.width = clipWidth;
          canvasCopy.height = clipHeight;
          copyContext === null || copyContext === void 0 ? void 0 : copyContext.drawImage(canvas, 0, 0, clipWidth, clipHeight);
          _this5.canvas = canvasCopy;
        }

        _this5.blob = null;
        _this5.modified = true;
        return {
          getBlob: function getBlob(type) {
            return _this5.getAsBlob(type);
          },
          getJpgUrl: function getJpgUrl() {
            return _this5.getJpgUrl();
          },
          getPngUrl: function getPngUrl() {
            return _this5.getPngUrl();
          },
          getImageUrl: function getImageUrl(type, quality) {
            return _this5.getImageUrl(type, quality);
          }
        };
      };

      return this.waitToLoad(fn);
    }
  }, {
    key: "waitToLoad",
    value: function waitToLoad(fn) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        switch (_this6.status) {
          case ImageStatus.PREPARE:
            reject('请先初始化图片!');
            break;

          case ImageStatus.REJECTED:
            reject('图片加载失败!');
            break;

          case ImageStatus.PENDING:
            _this6.resolvers.push(function () {
              return resolve(fn());
            });

            break;

          case ImageStatus.FULFILLED:
            resolve(fn());
            break;
        }
      });
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl(type, quality) {
      return this.canvas && this.canvas.toDataURL(type, (quality ? quality : this.quality) / 100);
    }
  }, {
    key: "getPngUrl",
    value: function getPngUrl(quality) {
      return this.getImageUrl('image/png', quality ? quality : this.quality);
    }
  }, {
    key: "getJpgUrl",
    value: function getJpgUrl(quality) {
      return this.getImageUrl('image/jpeg', quality ? quality : this.quality);
    }
  }, {
    key: "getAsBlob",
    value: function getAsBlob(type) {
      type = type ? type : this.type;
      var blob = this.blob;
      var dataUrl = '';

      if (this.modified || this.type !== type) {
        var canvas = this.canvas;

        if (type === 'image/jpeg') {
          dataUrl = canvas.toDataURL(type || this.type);

          if (this.preserveHeaders && this.meta && this.meta.imageHead) {
            var $buffer = dataURL2ArrayBuffer(dataUrl);
            var $bufferHead = updateImageHead($buffer, this.meta.imageHead);
            return arrayBufferToBlob($bufferHead, type);
          }
        } else {
          dataUrl = canvas.toDataURL();
        }

        blob = dataURL2Blob(dataUrl);
      }

      return blob;
    }
  }, {
    key: "resizeImage",
    value: function resizeImage(img, cvs, width, height, orientationType, isRotate) {
      var naturalWidth = img.width,
          naturalHeight = img.height;
      var orientation = orientationType || this.getOrientation();

      if (~[5, 6, 7, 8].indexOf(orientation)) {
        width ^= height;
        height ^= width;
        width ^= height;
      }

      var scale = Math[this.crop ? 'max' : 'min'](height / naturalWidth, width / naturalHeight);
      this.allowMagnify || (scale = Math.min(1, scale));
      var w = naturalWidth * scale;
      var h = naturalHeight * scale;

      if (this.crop) {
        cvs.width = width;
        cvs.height = height;
      } else {
        cvs.width = w;
        cvs.height = h;
      }

      var x = (cvs.width - w) / 2;
      var y = (cvs.height - h) / 2;

      if (isRotate || this.preserveHeaders) {
        this.rotate2Orientaion(cvs, orientation);
      }

      this.renderImageToCanvas(cvs, img, x, y, w, h);
    }
  }, {
    key: "getOrientation",
    value: function getOrientation() {
      return this.meta && this.meta.exif && this.meta.exif.get('Orientation') || 1;
    }
  }, {
    key: "rotate2Orientaion",
    value: function rotate2Orientaion(canvas, orientation) {
      var width = canvas.width;
      var height = canvas.height;
      var ctx = canvas.getContext('2d');

      switch (orientation) {
        case RotateDiection.VERTICAL_FLIP_ROTATE_RIGHT_90:
        case RotateDiection.ROTATE_RIGHT_90:
        case RotateDiection.HORIZONTAL_FLIP_ROTATE_RIGHT_90:
        case RotateDiection.ROTATE_LEFT_90:
          canvas.width = height;
          canvas.height = width;
          break;
      }

      switch (orientation) {
        case RotateDiection.HORIZONTAL_FLIP:
          ctx.translate(width, 0);
          ctx.scale(-1, 1);
          break;

        case RotateDiection.ROTATE_LEFT_180:
          ctx.translate(width, height);
          ctx.rotate(Math.PI);
          break;

        case RotateDiection.VERTICAL_FLIP:
          ctx.translate(0, height);
          ctx.scale(1, -1);
          break;

        case RotateDiection.VERTICAL_FLIP_ROTATE_RIGHT_90:
          ctx.rotate(0.5 * Math.PI);
          ctx.scale(1, -1);
          break;

        case RotateDiection.ROTATE_RIGHT_90:
          ctx.rotate(0.5 * Math.PI);
          ctx.translate(0, -height);
          break;

        case RotateDiection.HORIZONTAL_FLIP_ROTATE_RIGHT_90:
          ctx.rotate(0.5 * Math.PI);
          ctx.translate(width, -height);
          ctx.scale(-1, 1);
          break;

        case RotateDiection.ROTATE_LEFT_90:
          ctx.rotate(-0.5 * Math.PI);
          ctx.translate(-width, 0);
          break;
      }
    }
  }, {
    key: "renderImageToCanvas",
    value: function renderImageToCanvas(canvas, img, x, y, w, h) {
      var ctx = canvas.getContext('2d');
      ctx && ctx.drawImage(img, x, y, w, h);
    }
  }]);

  return ImageManage;
}();